import { Controller } from '@hotwired/stimulus';

import { renderBalancesGraph } from '../graphs/performance-balances-graph';

type BalanceValue = {
  date: string;
  balance: string;
  totalInvested: string;
  earned: string;
};

export default class extends Controller<HTMLElement> {
  declare balancesValue: BalanceValue[];

  static values = { balances: Array };

  balancesValueChanged(): void {
    this.render();
  }

  render(): void {
    const balances = this.balancesValue.map(balance => ({
      date: new Date(balance.date),
      balance: parseFloat(balance.balance),
      totalInvested: parseFloat(balance.totalInvested),
      earned: parseFloat(balance.earned),
    }));

    this.element.replaceChildren();
    renderBalancesGraph(this.element, { balanceByDate: balances });
  }
}
